import React from "react";
import {Link} from "react-router-dom";
import LogoUrl from '../../assets/img/logo.svg';
import LogoUrlFooter from '../../assets/img/logo_negative.svg';

const ComponentError = ({error, resetErrorBoundary}) => {
    return <>
        <header className="site-header">
            <div className="container container-max">
                <div className="row align-items-center">
                    <div className="col">
                        <Link to="/" className="logo">
                            <img src={LogoUrl}/>
                        </Link>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div className="site-content">
                <div className="container container-sm">
                    <div className="page-header">
                        <h1>Nåt gick fel.</h1>
                    </div>
                    <div className="page-content">
                        <div>Tyvärr uppstod ett fel när sidan skulle laddas. Du kan testa att ladda om sidan i webbläsaren
                            eller
                            kontrollera din internetanslutning. Om problemet kvarstår kan du gå tillbaka till startsidan
                            eller
                            kontakta vår support.<br />
                            <a href="/">Gå tillbaka till startsidan</a>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <footer className="site-footer">
            <div className="container">
                <div className="row">
                    <div className="col-md">
                        <Link to="/" className="logo">
                            <img src={LogoUrlFooter}/>
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    </>
}

export default ComponentError;
